var map = {
	"./deck-cards/1/1.svg": 436,
	"./deck-cards/1/10.svg": 437,
	"./deck-cards/1/11.svg": 438,
	"./deck-cards/1/12.svg": 439,
	"./deck-cards/1/13.svg": 440,
	"./deck-cards/1/14.svg": 441,
	"./deck-cards/1/15.svg": 442,
	"./deck-cards/1/16.svg": 443,
	"./deck-cards/1/17.svg": 444,
	"./deck-cards/1/18.svg": 445,
	"./deck-cards/1/19.svg": 446,
	"./deck-cards/1/2.svg": 447,
	"./deck-cards/1/20.svg": 448,
	"./deck-cards/1/21.svg": 449,
	"./deck-cards/1/22.svg": 450,
	"./deck-cards/1/23.svg": 451,
	"./deck-cards/1/24.svg": 452,
	"./deck-cards/1/25.svg": 453,
	"./deck-cards/1/26.svg": 454,
	"./deck-cards/1/27.svg": 455,
	"./deck-cards/1/28.svg": 456,
	"./deck-cards/1/29.svg": 457,
	"./deck-cards/1/3.svg": 458,
	"./deck-cards/1/30.svg": 459,
	"./deck-cards/1/31.svg": 460,
	"./deck-cards/1/32.svg": 461,
	"./deck-cards/1/33.svg": 462,
	"./deck-cards/1/34.svg": 463,
	"./deck-cards/1/35.svg": 464,
	"./deck-cards/1/36.svg": 465,
	"./deck-cards/1/37.svg": 466,
	"./deck-cards/1/38.svg": 467,
	"./deck-cards/1/39.svg": 468,
	"./deck-cards/1/4.svg": 469,
	"./deck-cards/1/40.svg": 470,
	"./deck-cards/1/41.svg": 471,
	"./deck-cards/1/42.svg": 472,
	"./deck-cards/1/43.svg": 473,
	"./deck-cards/1/44.svg": 474,
	"./deck-cards/1/45.svg": 475,
	"./deck-cards/1/46.svg": 476,
	"./deck-cards/1/47.svg": 477,
	"./deck-cards/1/48.svg": 478,
	"./deck-cards/1/49.svg": 479,
	"./deck-cards/1/5.svg": 480,
	"./deck-cards/1/50.svg": 481,
	"./deck-cards/1/51.svg": 482,
	"./deck-cards/1/52.svg": 483,
	"./deck-cards/1/6.svg": 484,
	"./deck-cards/1/7.svg": 485,
	"./deck-cards/1/8.svg": 486,
	"./deck-cards/1/9.svg": 487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;